
<template>
  <div id="page-shitfs-config">


    <vs-card title="Configurar Empresa">


      <div class="vx-col  mb-5" style="margin-top:10px">
        <vs-heading class="font-bold" level="2"
          style="margin-left: 20px; font-family: 'Arial', sans-serif; font-size: 20px;">Configurações da
          Empresa</vs-heading>

      </div>

      <div class="vx-col w-1/4  mb-5" style="margin-top:10px">
        <vs-heading class="font-bold" level="2"
          style="margin-left: 20px; font-family: 'Arial', sans-serif; font-size: 14px;">Dias de Trabalho</vs-heading>

      </div>

      <template>
        <vs-table style="margin-left: 20px; margin-right: 20px;">

          <template>

            <vs-th v-for="(day, index) in days" :key="index" class="text-center" :style="{ backgroundColor: '#ebe9f1' }"
              :sort-key="day">
              {{ day }}
            </vs-th>
            <vs-tr >
              <vs-td>
                <input type="checkbox" value="Sunday" id="Sunday" v-model="selectedDays" :disabled="!can_edit"/>
              </vs-td>
              <vs-td>
                <input type="checkbox" value="Monday" id="Monday" v-model="selectedDays" :disabled="!can_edit"/>
              </vs-td>
              <vs-td>
                <input type="checkbox" value="Tuesday" id="Tuesday" v-model="selectedDays" :disabled="!can_edit"/>
              </vs-td>
              <vs-td>
                <input type="checkbox" value="Wednesday" id="Wednesday" v-model="selectedDays" :disabled="!can_edit"/>
              </vs-td>
              <vs-td>
                <input type="checkbox" value="Thursday" id="Thursday" v-model="selectedDays" :disabled="!can_edit"/>
              </vs-td>
              <vs-td>
                <input type="checkbox" value="Friday" id="Friday" v-model="selectedDays" :disabled="!can_edit"/>
              </vs-td>
              <vs-td>
                <input type="checkbox" value="Saturday" id="Saturday" v-model="selectedDays" :disabled="!can_edit"/>
              </vs-td>
            </vs-tr>
          </template>

        </vs-table>
      </template>

      <template>

        <div class="vx-col w-1/4  mb-5" style="margin-top:10px">
          <vs-heading class="font-bold" level="2"
            style="margin-left: 20px; font-family: 'Arial', sans-serif; font-size: 14px;">Outras
            Configurações</vs-heading>

        </div>

        <div style="display: flex; margin-left: 20px; margin-right: 20px; margin-top: 10px;">
          <div style="width: 40%;">
            <label style="font-weight: 400; font-family: 'Arial', sans-serif; font-size: 15px; margin-bottom: 10px; "
              for="">Feriados Convertidos</label>

            <vs-select :disabled="!can_edit" @change="handleSelectChange" placeholder="Feriados Convertidos" multiple
              class="selectExample" v-model="holidaysSelected" style="margin-top: 5px; width: 100%;">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in holidays" />
            </vs-select>
          </div>



          <div style="width: 30%; margin-left: 20px;">
            <label style=" font-weight: 400; font-family: 'Arial', sans-serif;font-size: 15px; margin-bottom: 10px; "
              for="">Horas de Trabalho Turno</label>
            <vs-input :disabled="!can_edit" style="margin-top: 5px; width: 45%;" class="w-full" icon-pack="feather"
              icon-no-border v-model="work_hours_per_day_shift" type="number" name="Número de Horas"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Número de Horas')">{{ errors.first('Número de Horas')
            }}</span>
          </div>


        </div>


        <div style="display: flex; margin-left: 20px; margin-right: 20px; margin-top: 20px;">

          <div style="width: 40%; margin-left: 0px;">
            <label style=" font-weight: 400; font-family: 'Arial', sans-serif;font-size: 15px; margin-bottom: 10px; "
              for="">Horas de Trabalho - Noturno</label>
            <vs-input :disabled="!can_edit" style="margin-top: 5px; width: 45%;" class="w-full" icon-pack="feather"
              icon-no-border v-model="work_hours_per_day_shift_night" type="number" name="Número de Horas"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Número de Horas')">{{ errors.first('Número de Horas')
            }}</span>
          </div>

          <div style="width: 30%; margin-left: 20px;">
            <label style=" font-weight: 400; font-family: 'Arial', sans-serif;font-size: 15px; margin-bottom: 10px; "
              for="">Dias de Descanço - Turno</label>
            <vs-input :disabled="!can_edit" style="margin-top: 5px; width: 45%;" class="w-full" icon-pack="feather"
              icon-no-border v-model="days_off_per_week_shift" type="number" name="Número de Horas"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Número de Horas')">{{ errors.first('Número de Horas')
            }}</span>
          </div>

        </div>

        <div style="display: flex; margin-left: 20px; margin-right: 20px; margin-top: 20px;">
          <div style="width: 40%; margin-left: 0px;">
            <label style=" font-weight: 400; font-family: 'Arial', sans-serif;font-size: 15px; margin-bottom: 10px; "
              for="">Horas de Trabalho - Regime Normal</label>
            <vs-input :disabled="!can_edit" style="margin-top: 5px; width: 45%;" class="w-full" icon-pack="feather"
              icon-no-border v-model="work_hours_per_day" type="number" name="Número de Horas" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Número de Horas')">{{ errors.first('Número de Horas')
            }}</span>
          </div>

          <div style="width: 30%; margin-left: 20px;">
            <label style=" font-weight: 400; font-family: 'Arial', sans-serif;font-size: 15px; margin-bottom: 10px; "
              for="">Dias de Descanço - Turno de Noite</label>
            <vs-input :disabled="!can_edit" style="margin-top: 5px; width: 45%;" class="w-full" icon-pack="feather"
              icon-no-border v-model="days_off_per_week_night_shift" type="number" name="Número de Horas"
              v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Número de Horas')">{{ errors.first('Número de Horas')
            }}</span>
          </div>

        </div>

        <div style="display: flex; margin-left: 20px; margin-right: 20px; margin-top: 20px;">

          <div style="width: 40%; margin-left: 0px;">
            <label style=" font-weight: 400; font-family: 'Arial', sans-serif;font-size: 15px; margin-bottom: 10px; "
              for="">Data de Inicio de Atividade</label>
            <vs-input :disabled="!can_edit" style="margin-top: 5px; width: 45%;" class="w-full" icon-pack="feather"
              icon-no-border v-model="start_date" type="date" name="Número de Horas" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Número de Horas')">{{ errors.first('Número de Horas')
            }}</span>
          </div>

          <div style="width: 30%; margin-left: 20px;">
            <label style=" font-weight: 400; font-family: 'Arial', sans-serif;font-size: 15px; margin-bottom: 10px; "
              for="">Data de Enceramento de Actividade</label>
            <vs-input :disabled="!can_edit" style="margin-top: 5px; width: 45%;" class="w-full" icon-pack="feather"
              icon-no-border v-model="end_date" type="date" name="Número de Horas" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Número de Horas')">{{ errors.first('Número de Horas')
            }}</span>
          </div>

        </div>


      </template>


      <div style="margin-top: 10px; margin-right: 20px;" class="flex flex-wrap justify-end">
        <vs-button v-if="!can_edit" class="ml-2 mt-2 bg-black" @click="enableEdit">
          <vs-icon :icon="edit_icon" />Editar
        </vs-button>

        <vs-button v-if="can_edit" class="ml-2 mt-2 bg-danger" @click="enableEdit">
          Cancelar
        </vs-button>

        <vs-button v-if="can_edit & is_first" class="ml-2 mt-2" @click="saveConfiguration">Salvar</vs-button>

        <vs-button v-if="can_edit & !is_first" class="ml-2 mt-2" @click="updateConfiguration">Atualizar</vs-button>

      </div>

      <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>

    </vs-card>








  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import http from '../../../../http-common'
import http1 from '../../../../http1-common'
// Store Module

// Cell Renderer



export default {
  components: {
    AgGridVue,
    vSelect,


  },
  data() {
    return {
      work_days: [],
      edit_icon: 'lock',
      rest_days: [],
      can_edit: false,
      is_first: false,
      value1: '',
      value2: '',
      work_hours_per_day: '',
      days_off_per_week_shift: '',
      days_off_per_week_night_shift: '',
      work_hours_per_day_shift: '',
      work_hours_per_day_shift_night: '',
      company_id:'',
      popupApprove: false,
      vacations: [],
      selectedItem: '',
      selectedDay: null,
      selectedDays: [],
      unselectedDays: [],
      reason: '',
      holidays: [
        { text: '31 de Janeiro', value: '31-Jan' },
        { text: '03 de Fevereiro', value: '03-Fev' },
        { text: '25 de Junho', value: '25-Jun' },

      ],
      days: ['Domingo','Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado'],
      checkboxValues: [],
      holidaysSelected: [],
      data: [
        {
          employee: 'Edy Barrote',
          department: 'Software Development',
          start_date: '2023-01-05',
          end_date: '2023-01-15',
          duration: '10 dias',
          type: 'Singular',
          status: 'Recusado',
          reason: 'Motivo'
        },
        {
          employee: 'Kleyton',
          department: 'Software Development',
          start_date: '2023-01-15',
          end_date: '2023-01-20',
          duration: '5 dias',
          type: 'Colectivas',
          status: 'Aceite',
          reason: 'Motivo 2'
        },

      ],
      currentPage: 1,
      perPage: 1, // Number of items to display per page
      total: 2, // Total number of items
      size: 'normal', // Pagination size
      gradient: false, // Enable gradient effect
      rounded: false, // Enable rounded corners
      dense: false, // Use compact pagination style
    }
  },

  mounted() {
    this.initialize();
  },


  computed: {

  },
  watch:{
    selectedDays(index){
        console.log("Selected Days =>",index)
    }
  },


  methods: {
    initialize() {
      this.getUser();
      this.getConfiguration();
    },
    toggleCheckbox(index) {

      // if (this.selectedDays[index] === true) {
      //   this.selectedDays.push(index);

      // } else {
      //   this.selectedDays = this.selectedDays.filter(d => d !== index);
      // }

      if (this.selectedDays.includes(index)) {
        this.selectedDays = this.selectedDays.filter((value) => value !== index);
      } else {
        this.selectedDays.push(index);
      }



      console.log("selected dates ==>", this.selectedDays);


    },
    enableEdit() {
      if (this.can_edit === false) {
        this.can_edit = true;
        this.edit_icon = 'lock';
      } else {
        this.can_edit = false;
        //     this.edit_icon = 'pocket';
      }
    },


    handleSelectChange() {
      console.log('Selected Holidays:', this.holidaysSelected);
    },

    getUser() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type: 'sound'
      })



      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          type: 1
        }
      };

      http
        .get("/users/users", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.users = result.data.Users.reverse();

          // alert("2")
        })
        .catch((error) => {

          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    getConfiguration() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type: 'sound'
      })


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        }
      };

      http1
        .get("/shifts/company-settings", config)
        .then((result) => {

          this.$vs.loading.close('#div-with-loading > .con-vs-loading')

          console.log(result)
          
          if (result.data.length != 0) {
            this.is_first = false;

            this.holidaysSelected = result.data[0].holidays;
            this.days_off_per_week_night_shift = result.data[0].days_off_per_week_night_shift;
            this.days_off_per_week_shift = result.data[0].days_off_per_week_shift;
            this.work_hours_per_day = result.data[0].work_hours_per_day;
            this.work_hours_per_day_shift = result.data[0].work_hours_per_day_shift;
            this.work_hours_per_day_shift_night = result.data[0].work_hours_per_day_shift_night
            this.work_days = result.data[0].work_days;
            this.rest_days = result.data[0].rest_days;
            this.start_date = result.data[0].start_date;
            this.end_date = result.data[0].end_date;
            this.company_id = result.data[0].company_id;


            this.selectedDays = this.work_days;

            // this.checkboxValues = this.selectedDays //possibleDays.map((day) => this.selectedDays.includes(day))


            console.log('Data ==>', this.checkboxValues);

          }else{
            this.is_first = true;
          }

          // console.log('Configurations', this.vacations);
          // alert("2")
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    clickApproveHandler(item) {
      // Display the popup model and pass the data from the current row
      this.popupApprove = true;
      this.selectedItem = item; // Store the current row data in a variable for display in the popup
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { day: "numeric", month: "long", year: "numeric" };
      return date.toLocaleDateString("pt-PT", options); // Adjust the locale as needed
    },

    getStatusClass(status) {
      if (status === 'approved') {
        return 'vs-pill-success';
      } else if (status === 'pending') {
        return 'vs-pill-warning';
      } else if (status === 'rejected') {
        return 'vs-pill-danger';
      } else if (status === 'canceled') {
        return 'vs-pill-dark';
      }

      else {
        return '';
      }
    },

    getStatusName(status) {
      if (status === 'approved') {
        return 'Aprovado';
      } else if (status === 'pending') {
        return 'Pendente';
      } else if (status === 'rejected') {
        return 'Rejeitado';
      } else if (status === 'canceled') {
        return 'Cancelado';
      }

      else {
        return '';
      }
    },

    getTypeClass(type) {
      if (type === 'Singular') {
        return 'vs-pill-primary';
      } else if (type === 'Colectivas') {
        return 'vs-pill-secundary';
      } else {
        return '';
      }
    },

    getTypeText(type) {
      if (type === 'scheduled') {
        return 'Agendado';
      } else if (type === 'anticipated') {
        return 'Antecipado';
      } else if (type === 'anticipated') {
        return 'Adiado';
      } else {
        return '';
      }
    },
    cancelPopupApprove() {
      this.popupApprove = false;
    },
    saveConfiguration() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          setTimeout(() => {
            this.$vs.loading.close()
          }, 3000);
          let token = localStorage.getItem("token");
          let config = {
            headers: {
              authorization: "Bearer " + token,
            },
          };
          const uniqueSelectedDays = Array.from(new Set(this.selectedDays));
          const data = {
            work_days: uniqueSelectedDays,
            holidays: this.holidaysSelected,
            work_hours_per_day_shift: this.work_hours_per_day_shift,
            work_hours_per_day_shift_night: this.work_hours_per_day_shift_night,
            days_off_per_week_shift: this.days_off_per_week_shift,
            work_hours_per_day: this.work_hours_per_day,
            days_off_per_week_night_shift: this.days_off_per_week_night_shift,
            start_date: this.start_date,
            end_date: this.end_date
          };



          this.$validator.validateAll();
          http1
            .post("/shifts/company-settings", data, config)
            .then((success) => {
              success;
              this.reason = '';
              this.$vs.loading.close();
              this.popupApprove = false;
              this.$vs.notify({
                title: "Sucesso",
                text: "Configurações salva com sucesso",
                color: "success",
                position: "top-right",
              });

              this.getConfiguration()
              this.can_edit = false;

            })
            .catch((error) => {
              error;
              console.log("Error", error)
                this.err = error.response.data
                this.$vs.loading.close()
                this.$vs.notify({
                  title: "Erro",
                  text: this.err.message,
                  color: "danger",
                  position: "top-right",
                })
            });


        } else {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Preencha todos campos obrigatorios",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        }
      })
    },
    updateConfiguration(){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          setTimeout(() => {
            this.$vs.loading.close()
          }, 3000);
          let token = localStorage.getItem("token");
          let config = {
            headers: {
              authorization: "Bearer " + token,
            },
          };
          const uniqueSelectedDays = Array.from(new Set(this.selectedDays));
          const data = {
            work_days: uniqueSelectedDays,
            holidays: this.holidaysSelected,
            work_hours_per_day_shift: this.work_hours_per_day_shift,
            work_hours_per_day_shift_night: this.work_hours_per_day_shift_night,
            days_off_per_week_shift: this.days_off_per_week_shift,
            work_hours_per_day: this.work_hours_per_day,
            days_off_per_week_night_shift: this.days_off_per_week_night_shift,
            start_date: this.start_date,
            end_date: this.end_date,
            company_id: this.company_id
          };

          this.$validator.validateAll();
          http1
            .put("/shifts/company-settings/"+this.company_id, data, config)
            .then((success) => {
              success;
              this.reason = '';
              this.$vs.loading.close();
              this.popupApprove = false;
              this.$vs.notify({
                title: "Sucesso",
                text: "Connfigurações atualizadas com sucesso",
                color: "success",
                position: "top-right",
              });

              this.getConfiguration()
              this.can_edit = false;

            })
            .catch((error) => {
              error;
              console.log("Error", error)
                this.err = error.response.data
                this.$vs.loading.close()
                this.$vs.notify({
                  title: "Erro",
                  text: this.err.message,
                  color: "danger",
                  position: "top-right",
                })
            });


        } else {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Preencha todos campos obrigatorios",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        }
      })
    }




  }
}

</script>

<style>
/* Add styles for the pill colors */
.vs-pill-success {
  background-color: #28CF6F;
  color: white;
  padding: 5px;
}

.vs-pill-danger {
  background-color: #EA5455;
  color: white;
}

.vs-pill-warning {
  background-color: rgb(255, 159, 67);
  color: white;
}

.vs-pill-dark {
  background-color: rgb(168, 170, 174);
  color: white;
}

.vs-pill-primary {
  background-color: #00CFE8;
  color: white;
}

.vs-pill-secundary {
  background-color: #A8AAAC;
  color: white;
}
</style>

